import { utils, checkWin } from "@alife/cone-arms-core";
import { bindDomChangeEvent } from "./observe-domtree-change";
var bindEvent = utils.bindEvent;
// 记录滚屏次数
var scrollPageTimes = 0;
var startY = null;
var startX = null;
var horizontalScrollTimer;
var scrollTimer;
var initPageScrollEventTimer;
var initHorizontalScrollEventTimer;
var pageHeightRatio = 1;
/**
 * 滚动事件最小间隔时间
 */ var oneScrollEventTime = 200;
var pageScrollElement = null;
var firstScrollScreenTime = 0;
var initTime = 0;
var horizontalScrollElement = null;
var horizontalScrollTimes = 0;
var handleDocumentScroll = function() {
    var scrollTopHeight = document.documentElement.scrollTop;
    if (!startY) {
        startY = scrollTopHeight;
        return;
    }
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
        var height = document.documentElement.clientHeight;
        var endY = document.documentElement.scrollTop;
        var scrollHeight = startY ? Math.abs(endY - startY) : endY;
        if (scrollHeight > height / 4) {
            scrollPageTimes += 1;
            if (!firstScrollScreenTime && initTime) {
                firstScrollScreenTime = new Date().getTime() - initTime;
            }
        }
        startY = null;
    }, oneScrollEventTime);
};
var handleHorizontalScroll = function() {
    if (!horizontalScrollElement) {
        return;
    }
    var scrollLeftWidth = horizontalScrollElement.scrollLeft;
    //  获取scroll的起点
    if (!startX) {
        startX = scrollLeftWidth;
    }
    clearTimeout(horizontalScrollTimer);
    horizontalScrollTimer = setTimeout(function() {
        if (!horizontalScrollElement) {
            return;
        }
        var width = horizontalScrollElement.clientWidth;
        var endX = horizontalScrollElement.scrollLeft;
        var scrollWidth = startX ? Math.abs(endX - startX) : endX;
        if (scrollWidth > width / 4) {
            horizontalScrollTimes += 1;
        }
        startX = null;
    }, oneScrollEventTime);
};
var handlePageScroll = function() {
    if (!pageScrollElement) {
        return;
    }
    var scrollTopHeight = pageScrollElement.scrollTop;
    if (!startY) {
        startY = scrollTopHeight;
        return;
    }
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
        if (!pageScrollElement || !pageScrollElement.clientHeight) {
            return;
        }
        var height = pageScrollElement.clientHeight;
        var endY = pageScrollElement.scrollTop;
        var scrollHeight = startY ? Math.abs(endY - startY) : endY;
        if (scrollHeight > height / 4) {
            scrollPageTimes += 1;
            if (!firstScrollScreenTime && initTime) {
                firstScrollScreenTime = new Date().getTime() - initTime;
            }
        }
        startY = null;
    }, oneScrollEventTime);
};
var initPageScrollEvent = function(unbindFnList) {
    var retryTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (retryTimes > 20) {
        return;
    }
    if (initPageScrollEventTimer) {
        clearTimeout(initPageScrollEventTimer);
    }
    initPageScrollEventTimer = setTimeout(function() {
        var curPageScrollElement = document.querySelector('[data-scroll-element-type="page"]') || document.getElementById("cn-ui-page-scroll-container");
        if (curPageScrollElement) {
            if (curPageScrollElement !== pageScrollElement) {
                pageScrollElement = curPageScrollElement;
                unbindFnList.push(bindEvent(pageScrollElement, "scroll", handlePageScroll));
            }
        } else {
            initPageScrollEvent(unbindFnList, retryTimes + 1);
        }
    }, 300);
};
var initHorizontalScrollEvent = function(unbindFnList) {
    var retryTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (retryTimes > 20) {
        return;
    }
    if (initHorizontalScrollEventTimer) {
        clearTimeout(initHorizontalScrollEventTimer);
    }
    initHorizontalScrollEventTimer = setTimeout(function() {
        horizontalScrollElement = document.querySelector('[data-scroll-element-type="horizontal-table"]');
        if (horizontalScrollElement) {
            unbindFnList.push(bindEvent(horizontalScrollElement, "scroll", handleHorizontalScroll));
        } else {
            initHorizontalScrollEvent(unbindFnList, retryTimes + 1);
        }
    }, 300);
};
var calcPageHeightRatio = function() {
    var newPageHeightRatio = pageScrollElement && pageScrollElement.clientHeight > 0 ? pageScrollElement.scrollHeight / pageScrollElement.clientHeight : document.documentElement.scrollHeight / document.documentElement.clientHeight || 0;
    // 记录页面内容最长的
    if (newPageHeightRatio > pageHeightRatio) {
        pageHeightRatio = Math.floor(newPageHeightRatio) === newPageHeightRatio ? newPageHeightRatio : Number(newPageHeightRatio.toFixed(2));
    }
};
var unbindFnList = [];
export var init = function() {
    var unbindScroll = function() {
        clearTimeout(scrollTimer);
        clearTimeout(horizontalScrollTimer);
        clearTimeout(initPageScrollEventTimer);
        clearTimeout(initHorizontalScrollEventTimer);
        unbindFnList.forEach(function(unbindFn) {
            unbindFn();
        });
    };
    if (checkWin()) {
        initTime = new Date().getTime();
        unbindFnList.push(bindEvent(document, "scroll", handleDocumentScroll));
        initPageScrollEvent(unbindFnList);
        initHorizontalScrollEvent(unbindFnList);
        bindDomChangeEvent(calcPageHeightRatio);
    }
    return unbindScroll;
};
export var reset = function() {
    scrollPageTimes = 0;
    firstScrollScreenTime = 0;
    pageHeightRatio = 1;
    initTime = new Date().getTime();
    if (checkWin()) {
        initPageScrollEvent(unbindFnList);
    }
};
export var getData = function() {
    if (!checkWin()) {
        return {};
    }
    return {
        scrollPageTimes: scrollPageTimes,
        firstScrollScreenTime: firstScrollScreenTime,
        horizontalScrollTimes: horizontalScrollTimes,
        pageHeightRatio: pageHeightRatio
    };
};

 //# sourceMappingURL=observe-page-scroll.js.map